(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oh-cart-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';

  const isLegacyOfferLine = item => String(item?.properties?._oh_gift) === '1' || String(item?.properties?._gift) === 'true';
  const cleanCode = value => typeof value === 'string' ? value.trim() : '';
  const sameCode = (first, second) => String(first).toUpperCase() === String(second).toUpperCase();
  const discountCodes = cart => (Array.isArray(cart?.discount_codes) ? cart.discount_codes : []).filter(entry => typeof entry?.code === 'string').map(entry => ({ code: entry.code, applicable: typeof entry.applicable === 'boolean' ? entry.applicable : null }));
  const positiveAllocations = (allocations, field = 'amount') => (Array.isArray(allocations) ? allocations : []).filter(allocation => Number.isFinite(Number(allocation?.[field])) && Number(allocation[field]) > 0);
  const normalizeCartDiscounts = allocations => positiveAllocations((Array.isArray(allocations) ? allocations : []).map(allocation => {
    const application = allocation?.discount_application && typeof allocation.discount_application === 'object' ? allocation.discount_application : allocation || {};
    const amounts = [allocation?.total_allocated_amount, allocation?.amount, application.total_allocated_amount];
    const amount = amounts.find(value => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)));
    return { title: application.title || allocation?.title || '', total_allocated_amount: amount === undefined ? null : Number(amount) };
  }), 'total_allocated_amount');
  const validCart = value => Boolean(value && Array.isArray(value.items) && Number.isFinite(value.total_price) && Number.isFinite(value.items_subtotal_price) && Number.isSafeInteger(value.item_count) && value.item_count >= 0 && value.items.every(item => typeof item.key === 'string' && Number.isSafeInteger(item.quantity) && item.quantity > 0 && Number.isFinite(item.final_line_price) && item.final_line_price >= 0));
  const propertySignature = properties => JSON.stringify(Object.entries(properties || {}).filter(([, value]) => value !== null && value !== '').map(([key, value]) => [key, String(value)]).sort(([a], [b]) => a.localeCompare(b)));
  const identity = item => `${item.variant_id || item.id}|${propertySignature(item.properties)}|${item.selling_plan_allocation?.selling_plan?.id || ''}`;
  const identityQuantity = (cart, signature) => (cart?.items || []).reduce((sum, item) => sum + (identity(item) === signature ? item.quantity : 0), 0);
  const inputIdentity = input => `${input.id}|${propertySignature(input.properties)}|${input.selling_plan || ''}`;
  const inputQuantity = (cart, input) => (cart?.items || []).filter(item => identity(item) === inputIdentity(input)).reduce((sum, item) => sum + Number(item.quantity), 0);
  const parseLineQuantity = value => {
    if (typeof value !== 'number' && (typeof value !== 'string' || !value.trim())) return null;
    const quantity = Number(value);
    return Number.isSafeInteger(quantity) && quantity >= 0 ? quantity : null;
  };
  const readLineQuantities = (inputs, cart, onInvalid) => {
    let invalid = null;
    const entries = Array.from(inputs, input => {
      const quantity = parseLineQuantity(input.value);
      if (quantity === null || !input.checkValidity()) {
        const previous = cart?.items.find(item => item.key === input.dataset.ohLineQuantity)?.quantity ?? parseLineQuantity(input.defaultValue);
        if (previous !== null && previous !== undefined) input.value = String(previous);
        invalid ||= input;
      }
      return { key: input.dataset.ohLineQuantity, quantity };
    });
    if (invalid) { onInvalid?.(invalid); return null; }
    return entries;
  };

  function createCartController(options) {
    let cart = validCart(options.initialCart) ? options.initialCart : null;
    let queue = Promise.resolve();
    let pending = 0;
    let uncertain = false;
    let stale = false;
    let pendingDiscount = cleanCode(options.pendingDiscount);
    let discount = { code: pendingDiscount, status: pendingDiscount ? 'pending' : 'idle', message: '' };
    const hasLegacyOffers = () => Boolean(cart?.items.some(isLegacyOfferLine));
    const text = options.text || (key => key);
    const notify = (key, error = false, custom = '') => options.notify?.(custom || text(key), error);
    const messageOf = (response, fallback) => typeof response?.data?.description === 'string' ? response.data.description : typeof response?.data?.message === 'string' ? response.data.message : text(fallback);
    const discountSnapshot = () => {
      const codes = discountCodes(cart);
      let status = discount.status;
      if (status === 'rejected' && codes.some(entry => sameCode(entry.code, discount.code) && entry.applicable === true)) status = 'applied';
      if (status === 'applied') {
        const entry = codes.find(item => sameCode(item.code, discount.code));
        if (!Array.isArray(cart?.discount_codes) || entry?.applicable === null) status = 'unknown';
        else if (!entry) status = 'removed';
        else if (!entry.applicable) status = 'rejected';
      }
      const code = discount.code;
      return { code, status, applied: status === 'applied', pending: status === 'pending', removed: status === 'removed', outcomeUnknown: status === 'unknown', error: ['rejected', 'unknown'].includes(status), message: (status === discount.status ? discount.message : '') || (status === 'idle' ? '' : text(`discount_${status}`, { code })), cart, codes };
    };
    const announceDiscount = () => {
      const state = discountSnapshot();
      options.discountState?.(state);
      options.emit?.('oh:discount-updated', state);
      return state;
    };
    const setDiscount = (code, status, message = '') => {
      discount = { code, status, message };
      return announceDiscount();
    };
    const savePendingDiscount = code => {
      pendingDiscount = code;
      options.savePendingDiscount?.(code);
    };
    const publish = value => {
      cart = value;
      options.render?.(cart);
      options.emit?.('oh:cart-updated', { cart });
      announceDiscount();
    };
    const serialize = work => {
      pending += 1;
      options.pending?.(true);
      const result = queue.then(work);
      queue = result.catch(() => {});
      result.then(() => {
        pending -= 1;
        options.pending?.(pending > 0);
      }, () => {
        pending -= 1;
        options.pending?.(pending > 0);
      });
      return result;
    };
    async function readCart() {
      const response = await options.request('cart');
      if (!response.ok || !validCart(response.data)) throw new Error(text('refresh_error'));
      stale = false;
      publish(response.data);
      return cart;
    }
    async function recoverCart() {
      try { return await readCart(); } catch { stale = true; return null; }
    }
    function announceAdded(input, quantity, item) {
      options.emit?.('oh:added', { id: String(input.id), quantity, item: item || null });
    }
    function findCurrentLine(key, descriptor, allowRekey = true) {
      const exact = cart?.items.find(item => item.key === key);
      if (exact) return exact;
      const equivalent = descriptor && allowRekey ? cart?.items.filter(item => identity(item) === descriptor) : [];
      return equivalent?.length === 1 ? equivalent[0] : null;
    }
    async function addCore(input) {
      if (!/^\d+$/.test(String(input.id)) || !Number.isSafeInteger(Number(input.quantity)) || Number(input.quantity) < 1) throw new Error(text('invalid_quantity'));
      if (isLegacyOfferLine(input)) throw new Error(text('legacy_offer_error'));
      if (uncertain) {
        notify('outcome_unknown', true);
        return { added: false, cart, refreshFailed: true, outcomeUnknown: true };
      }
      if (!cart || stale) {
        if (!await recoverCart()) throw new Error(text('refresh_error'));
      }
      const normalized = { id: String(input.id), quantity: Number(input.quantity), properties: { ...(input.properties || {}) } };
      const before = inputQuantity(cart, normalized);
      let response;
      try { response = await options.request('add', { items: [normalized] }); } catch { response = null; }
      const addedItem = Array.isArray(response?.data?.items) ? response.data.items.find(item => String(item.variant_id || item.id) === normalized.id) : response?.data?.id ? response.data : null;
      if (response?.ok && addedItem && Number(addedItem.quantity) > 0) {
        const item = addedItem;
        const refreshed = await recoverCart();
        const observed = refreshed ? inputQuantity(refreshed, normalized) - before : null;
        const quantity = observed !== null && observed > 0 ? Math.min(observed, normalized.quantity) : normalized.quantity;
        announceAdded(normalized, quantity, item || refreshed?.items.find(line => identity(line) === inputIdentity(normalized)));
        notify(refreshed ? 'added' : 'added_refresh_error', !refreshed);
        return { added: true, cart: refreshed, refreshFailed: !refreshed, quantity };
      }
      const refreshed = await recoverCart();
      const increment = refreshed ? inputQuantity(refreshed, normalized) - before : 0;
      if (increment > 0) {
        const quantity = Math.min(increment, normalized.quantity);
        announceAdded(normalized, quantity, refreshed.items.find(line => identity(line) === inputIdentity(normalized)));
        notify('inventory_adjusted', false, response ? messageOf(response, 'inventory_adjusted') : '');
        return { added: true, cart: refreshed, refreshFailed: false, quantity, partial: quantity < normalized.quantity };
      }
      if (response && response.status >= 400 && response.status < 500 && (response.status !== 422 || refreshed)) {
        throw new Error(messageOf(response, 'add_error'));
      }
      uncertain = true;
      stale = true;
      notify('outcome_unknown', true);
      return { added: false, cart: refreshed || cart, refreshFailed: !refreshed, outcomeUnknown: true };
    }
    async function changeCore(key, quantity, descriptor, allowRekey = true) {
      const normalizedQuantity = parseLineQuantity(quantity);
      if (normalizedQuantity === null) throw new Error(text('change_error'));
      if (uncertain) { notify('outcome_unknown', true); return { changed: false, cart, outcomeUnknown: true }; }
      const line = findCurrentLine(key, descriptor, allowRekey);
      if (!line) { await recoverCart(); throw new Error(text('stale_line')); }
      const target = isLegacyOfferLine(line) ? 0 : normalizedQuantity;
      if (line.quantity === target) return { changed: true, cart };
      const signature = identity(line);
      const expectedQuantity = identityQuantity(cart, signature) - line.quantity + target;
      let response;
      try { response = await options.request('change', { id: line.key, quantity: target }); } catch { response = null; }
      if (response?.ok && validCart(response.data)) {
        publish(response.data);
        if (target > 0 && identityQuantity(cart, signature) !== expectedQuantity) notify('inventory_adjusted');
        return { changed: true, cart };
      }
      const refreshed = await recoverCart();
      if (refreshed && identityQuantity(refreshed, signature) === expectedQuantity) return { changed: true, cart };
      if (response && response.status >= 400 && response.status < 500) throw new Error(messageOf(response, 'change_error'));
      uncertain = true;
      stale = true;
      notify('outcome_unknown', true);
      return { changed: false, cart, outcomeUnknown: true };
    }
    async function reconcileLegacyOffers() {
      if (!hasLegacyOffers()) return true;
      if (!cart || uncertain || stale) { notify('legacy_offer_error', true); return false; }
      const limit = cart.items.length;
      try {
        for (let attempt = 0; attempt < limit && hasLegacyOffers(); attempt += 1) {
          const line = cart.items.find(isLegacyOfferLine);
          const result = await changeCore(line.key, 0, identity(line), false);
          if (!result.changed || cart.items.some(item => item.key === line.key)) break;
        }
      } catch {}
      const removed = !hasLegacyOffers() && !uncertain && !stale;
      notify(removed ? 'legacy_offer_removed' : 'legacy_offer_error', !removed);
      return removed;
    }
    async function discountCore(value, remove = false) {
      const code = cleanCode(value);
      if (!code || code.length > 255 || /[,\x00-\x1f\x7f]/.test(code)) return setDiscount(code, 'rejected', text('discount_invalid'));
      if (!remove && pendingDiscount && !sameCode(pendingDiscount, code)) savePendingDiscount('');
      if (uncertain || ((!cart || stale) && !await recoverCart())) return setDiscount(code, 'unknown');
      if (!remove && !cart.items.some(item => !isLegacyOfferLine(item))) {
        savePendingDiscount(code);
        return setDiscount(code, 'pending');
      }
      if (remove && sameCode(pendingDiscount, code)) {
        savePendingDiscount('');
        if (!discountCodes(cart).some(entry => sameCode(entry.code, code))) return setDiscount(code, 'removed');
      }
      if (!Array.isArray(cart.discount_codes) && !await recoverCart()) return setDiscount(code, 'unknown');
      if (!Array.isArray(cart.discount_codes)) return setDiscount(code, 'unknown');
      const currentCodes = discountCodes(cart);
      if (!remove && currentCodes.some(entry => sameCode(entry.code, code) && entry.applicable)) {
        if (sameCode(pendingDiscount, code)) savePendingDiscount('');
        return setDiscount(code, 'applied');
      }
      const requestedCodes = currentCodes.filter(entry => !sameCode(entry.code, code)).map(entry => entry.code);
      if (!remove) requestedCodes.push(code);
      if (sameCode(pendingDiscount, code)) savePendingDiscount('');
      let response;
      try { response = await options.request('update', { discount: requestedCodes.join(',') }); } catch { response = null; }
      let authoritative = false;
      if (response?.ok && validCart(response.data)) {
        publish(response.data);
        authoritative = Array.isArray(cart.discount_codes);
      }
      if (!authoritative) authoritative = Boolean(await recoverCart()) && Array.isArray(cart.discount_codes);
      if (authoritative) {
        await reconcileLegacyOffers();
        const entry = discountCodes(cart).find(item => sameCode(item.code, code));
        if (remove && !entry) return setDiscount(code, 'removed');
        if (!remove && entry?.applicable === true) return setDiscount(code, 'applied');
        if (!remove && (entry?.applicable === false || response?.ok && !entry)) return setDiscount(code, 'rejected');
      }
      if (response && response.status >= 400 && response.status < 500) return setDiscount(code, 'rejected', typeof response.data?.description === 'string' ? response.data.description : text('discount_rejected', { code }));
      return setDiscount(code, 'unknown');
    }
    async function applyPendingDiscount() {
      if (pendingDiscount && cart?.items.some(item => !isLegacyOfferLine(item)) && !uncertain && !stale) await discountCore(pendingDiscount);
    }
    const captureEntries = entries => entries.map(entry => {
      const original = cart?.items.find(line => line.key === entry.key);
      const descriptor = original ? identity(original) : '';
      const allowRekey = Boolean(descriptor) && cart.items.filter(line => identity(line) === descriptor).length === 1;
      return { ...entry, quantity: parseLineQuantity(entry.quantity), descriptor, allowRekey, legacy: isLegacyOfferLine(original) };
    });
    return {
      get cart() { return cart; },
      get pending() { return pending > 0; },
      get stale() { return stale || uncertain; },
      get hasLegacyOffers() { return hasLegacyOffers(); },
      get discountState() { return discountSnapshot(); },
      applyDiscount: code => serialize(() => discountCore(code)),
      removeDiscount: code => serialize(() => discountCore(code, true)),
      add(input) {
        return serialize(async () => {
          const result = await addCore(input);
          if (result.added && !result.refreshFailed) {
            await applyPendingDiscount();
            await reconcileLegacyOffers();
            result.refreshFailed = stale || uncertain;
            result.cart = result.refreshFailed ? null : cart;
            if (result.refreshFailed) notify('added_refresh_error', true);
          }
          return result;
        });
      },
      change(key, quantity) {
        const original = cart?.items.find(line => line.key === key);
        const descriptor = original ? identity(original) : '';
        const allowRekey = Boolean(descriptor) && cart.items.filter(line => identity(line) === descriptor).length === 1;
        const normalizedQuantity = parseLineQuantity(quantity);
        return serialize(async () => {
          if (normalizedQuantity === null) throw new Error(text('change_error'));
          const result = await changeCore(key, normalizedQuantity, descriptor, allowRekey);
          if (result.changed) await reconcileLegacyOffers();
          return { ...result, cart };
        });
      },
      update(entries) {
        const captured = captureEntries(entries);
        return serialize(async () => {
          if (captured.some(entry => entry.quantity === null)) throw new Error(text('change_error'));
          for (const entry of captured) {
            const result = await changeCore(entry.key, entry.quantity, entry.descriptor, entry.allowRekey);
            if (!result.changed) return result;
          }
          await reconcileLegacyOffers();
          return { changed: true, cart };
        });
      },
      refresh() {
        return serialize(async () => {
          try {
            await readCart();
            uncertain = false;
            await applyPendingDiscount();
            await reconcileLegacyOffers();
            return cart;
          } catch (error) { stale = true; notify('refresh_error', true); throw error; }
        });
      },
      prepareCheckout(entries = []) {
        const captured = captureEntries(entries);
        return serialize(async () => {
          if (captured.some(entry => entry.quantity === null)) throw new Error(text('change_error'));
          if (!await recoverCart()) { notify('refresh_error', true); return { ready: false, cart }; }
          uncertain = false;
          for (const entry of captured.filter(entry => !entry.legacy)) {
            const result = await changeCore(entry.key, entry.quantity, entry.descriptor, entry.allowRekey);
            if (!result.changed) return { ready: false, cart };
          }
          await applyPendingDiscount();
          const reconciled = await reconcileLegacyOffers();
          return { ready: reconciled && !uncertain && !stale && cart.item_count > 0, cart };
        });
      }
    };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { createCartController, isLegacyOfferLine, identity, positiveAllocations, normalizeCartDiscounts, parseLineQuantity, readLineQuantities };
    return;
  }

  function boot() {
    if (window.OHCart) return;
    const parse = node => { try { return JSON.parse(node?.textContent || '{}'); } catch { return {}; } };
    const rootConfig = parse(document.getElementById('oh-config'));
    const words = parse(document.getElementById('oh-cart-language'));
    const translate = (key, values = {}) => Object.entries(values).reduce((value, [name, replacement]) => value.replaceAll(`__${name}__`, String(replacement)), words[key] || '');
    const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
    const routeRoot = rootConfig.routes?.root || window.Shopify?.routes?.root || '/';
    const endpoint = name => {
      const configured = rootConfig.routes?.[name];
      const path = configured || `${routeRoot}${name === 'cart' ? 'cart' : `cart/${name}`}`;
      return path.endsWith('.js') ? path : `${path}.js`;
    };
    const cartURL = rootConfig.routes?.cart || `${routeRoot}cart`;
    const safeURL = (value, image = false) => {
      if (!value || typeof value !== 'string') return image ? '' : cartURL;
      try {
        const url = new URL(value, window.location.origin);
        if (!['https:', 'http:'].includes(url.protocol) || (!image && url.origin !== window.location.origin)) return image ? '' : cartURL;
        return url.href;
      } catch { return image ? '' : cartURL; }
    };
    const money = cents => {
      const currency = controller?.cart?.currency || rootConfig.currency || 'USD';
      try { return new Intl.NumberFormat(rootConfig.locale || document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(cents || 0) / 100); } catch { return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`; }
    };
    let controller;
    let opener = null;
    let oldOverflow = '';
    const dialog = document.getElementById('oh-cart-drawer');
    const surfaces = () => Array.from(document.querySelectorAll('[data-oh-cart-surface]'));
    let noticeRevision = 0;
    const notices = (message, error = false) => {
      noticeRevision += 1;
      surfaces().forEach(surface => {
        const node = surface.querySelector('[data-oh-cart-notice]');
        node.textContent = message;
        node.hidden = !message;
        surface.querySelector('[data-oh-cart-refresh]').hidden = !error;
      });
    };
    const runUpdate = action => {
      notices(translate('updating'));
      const revision = noticeRevision;
      return action().then(result => {
        if (!result?.outcomeUnknown && noticeRevision === revision) notices(translate('updated'));
        return result;
      }).catch(error => { notices(error.message, true); });
    };
    const quantityEntries = inputs => readLineQuantities(inputs, controller.cart, () => notices(translate('change_error')));
    const paintDiscount = state => {
      surfaces().forEach(surface => {
        const form = surface.querySelector('[data-oh-discount-form]');
        if (!form) return;
        form.hidden = false;
        const status = surface.querySelector('[data-oh-discount-status]');
        status.textContent = state.message;
        status.hidden = !state.message;
        status.classList.toggle('is-error', state.error);
        const codes = state.codes.map(entry => ({ code: entry.code, pending: false, applicable: entry.applicable }));
        if (state.pending && !codes.some(entry => sameCode(entry.code, state.code))) codes.push({ code: state.code, pending: true });
        surface.querySelector('[data-oh-discount-codes]').innerHTML = codes.map(entry => `<span class="oh-cart__code"><span>${esc(entry.code)}${entry.pending ? ` · ${esc(translate('discount_saved'))}` : entry.applicable !== true ? ` · ${esc(translate('discount_not_applied'))}` : ''}</span><button type="button" data-oh-discount-remove="${esc(entry.code)}" aria-label="${esc(translate('discount_remove', { code: entry.code }))}" ${controller.pending ? 'disabled' : ''}><span aria-hidden="true">×</span></button></span>`).join('');
        form.querySelector('button').disabled = controller.pending;
        form.querySelector('input').setAttribute('aria-invalid', String(state.status === 'rejected'));
      });
    };
    const setPending = pending => {
      surfaces().forEach(surface => {
        surface.setAttribute('aria-busy', String(pending));
        surface.querySelectorAll('[data-oh-line-quantity], [data-oh-cart-update]').forEach(node => { node.disabled = pending || controller.stale; });
        surface.querySelectorAll('[data-oh-cart-checkout]').forEach(node => { node.disabled = pending || controller.hasLegacyOffers; });
        surface.querySelectorAll('[data-oh-discount-apply], [data-oh-discount-remove]').forEach(node => { node.disabled = pending; });
        surface.querySelectorAll('[data-oh-line-remove]').forEach(node => node.setAttribute('aria-disabled', String(pending || controller.stale)));
      });
    };
    const lineHTML = (item, index, context) => {
      const title = item.product_title || item.title || '';
      const link = safeURL(item.url);
      const image = safeURL(item.featured_image?.url || item.image || '', true);
      const key = esc(item.key);
      const quantityId = `oh-cart-qty-${context}-${index}`;
      const variant = item.product_has_only_default_variant || item.variant_title === 'Default Title' ? '' : item.variant_title || '';
      const properties = Object.entries(item.properties || {}).filter(([name, value]) => !name.startsWith('_') && value !== '' && value !== null).map(([name, value]) => `<p class="oh-cart__variant">${esc(name)}: ${esc(value)}</p>`).join('');
      const legacyOffer = isLegacyOfferLine(item);
      const discounts = positiveAllocations(item.line_level_discount_allocations || item.discount_allocations).map(allocation => `<p class="oh-cart__discount">${esc(allocation.discount_application?.title || allocation.title || translate('discount'))} (−${esc(money(allocation.amount))})</p>`).join('');
      const removeURL = `${routeRoot}cart/change?id=${encodeURIComponent(item.key)}&quantity=0`;
      const quantity = legacyOffer ? `<input id="${quantityId}" type="hidden" name="updates[]" value="0" data-oh-line-quantity="${key}" readonly>` : `<label class="oh-cart__quantity" for="${quantityId}"><span>${esc(translate('quantity'))}</span><input id="${quantityId}" type="number" name="updates[]" min="0" step="1" value="${Number(item.quantity)}" inputmode="numeric" data-oh-line-quantity="${key}" aria-label="${esc(translate('quantity_for', { product: title }))}"></label>`;
      return `<article class="oh-cart__line" data-oh-line-key="${key}">
        <a class="oh-cart__image-link" href="${esc(link)}" tabindex="-1" aria-hidden="true">${image ? `<img class="oh-cart__image" src="${esc(image)}" width="72" height="72" alt="" loading="lazy">` : ''}</a>
        <div class="oh-cart__line-copy"><a class="oh-cart__product" href="${esc(link)}">${esc(title)}</a>
        ${variant ? `<p class="oh-cart__variant">${esc(variant)}</p>` : ''}${item.selling_plan_allocation ? `<p class="oh-cart__variant">${esc(item.selling_plan_allocation.selling_plan?.name)}</p>` : ''}${properties}
        <div class="oh-cart__line-price">${item.original_line_price > item.final_line_price ? `<s>${esc(money(item.original_line_price))}</s>` : ''}<span>${esc(money(item.final_line_price))}</span></div>${discounts}
        ${legacyOffer ? `<p class="oh-cart__line-error">${esc(translate('legacy_offer_pending'))}</p>` : ''}
        ${item.error_message ? `<p class="oh-cart__line-error">${esc(item.error_message)}</p>` : ''}
        <div class="oh-cart__line-actions">${quantity}<a class="oh-cart__remove" href="${esc(removeURL)}" data-oh-line-remove="${key}" aria-label="${esc(translate('remove_item', { product: title }))}">${esc(translate('remove'))}</a></div></div></article>`;
    };
    const render = cart => {
      const focused = document.activeElement;
      const focusSurface = focused?.closest('[data-oh-cart-surface]');
      const focusLine = focused?.closest('[data-oh-line-key]');
      const focusIndex = focusLine && focusSurface ? Array.from(focusSurface.querySelectorAll('[data-oh-line-key]')).indexOf(focusLine) : -1;
      const focusKind = focused?.hasAttribute('data-oh-line-quantity') ? '[data-oh-line-quantity]' : '[data-oh-line-remove]';
      surfaces().forEach(surface => {
        surface.querySelector('[data-oh-cart-lines]').innerHTML = cart.items.map((item, index) => lineHTML(item, index, surface.dataset.ohCartSurface)).join('');
        surface.querySelector('[data-oh-cart-empty]').hidden = cart.item_count > 0;
        surface.querySelector('[data-oh-cart-update]').hidden = cart.item_count === 0;
        surface.querySelector('[data-oh-cart-totals]').hidden = cart.item_count === 0;
        surface.querySelector('[data-oh-cart-subtotal]').textContent = money(cart.items_subtotal_price);
        surface.querySelector('[data-oh-cart-total]').textContent = money(cart.total_price);
        surface.querySelector('[data-oh-cart-discounts]').innerHTML = normalizeCartDiscounts(cart.cart_level_discount_applications).map(discount => `<div><span>${esc(discount.title || translate('discount'))}</span><span>−${esc(money(discount.total_allocated_amount))}</span></div>`).join('');
      });
      document.querySelectorAll('[data-oh-cart-count]').forEach(node => { node.textContent = String(cart.item_count); });
      setPending(controller.pending);
      if (focusIndex >= 0 && focusSurface) {
        const lines = focusSurface.querySelectorAll('[data-oh-line-key]');
        const target = lines[Math.min(focusIndex, lines.length - 1)]?.querySelector(focusKind) || focusSurface.querySelector('h1, h2');
        requestAnimationFrame(() => { if (target && !target.disabled) target.focus({ preventScroll: true }); });
      }
    };
    const request = async (name, payload) => {
      const abort = new AbortController();
      const timer = setTimeout(() => abort.abort(), 12000);
      try {
        const response = await fetch(endpoint(name), { method: payload ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(payload ? { 'Content-Type': 'application/json' } : {}) }, ...(payload ? { body: JSON.stringify(payload) } : {}), signal: abort.signal });
        let data = null;
        try { data = await response.json(); } catch {}
        return { ok: response.ok, status: response.status, data };
      } finally { clearTimeout(timer); }
    };
    let pendingCode = '';
    try { pendingCode = sessionStorage.getItem('oh-after-hours-pending-discount') || ''; } catch {}
    controller = createCartController({ initialCart: parse(document.getElementById('oh-cart-initial')), pendingDiscount: pendingCode, request, text: translate, notify: notices, render, pending: setPending, discountState: paintDiscount,
      emit: (name, detail) => document.dispatchEvent(new CustomEvent(name, { detail })),
      savePendingDiscount: value => { try { if (value) sessionStorage.setItem('oh-after-hours-pending-discount', value); else sessionStorage.removeItem('oh-after-hours-pending-discount'); } catch {} }
    });
    const close = () => { if (dialog?.open) dialog.close(); };
    const open = (refresh = true) => {
      if (!dialog?.showModal) { window.location.assign(cartURL); return; }
      if (!dialog.open) {
        opener = document.activeElement;
        oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        document.body.classList.add('oh-cart-open');
        dialog.showModal();
        dialog.querySelector('[data-oh-cart-close]')?.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('oh:cart-open'));
      }
      if (refresh) controller.refresh().catch(() => {});
    };
    dialog?.addEventListener('close', () => {
      document.body.style.overflow = oldOverflow;
      document.body.classList.remove('oh-cart-open');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('oh:cart-close'));
    });
    dialog?.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog?.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    window.OHCart = {
      add: input => controller.add(input).then(result => { if (result.added || result.outcomeUnknown) open(false); return result; }),
      open: () => open(), close,
      refresh: () => controller.refresh(),
      applyDiscount: code => controller.applyDiscount(code),
      removeDiscount: code => controller.removeDiscount(code),
      get discountState() { return controller.discountState; },
      get cart() { return controller.cart; }
    };
    document.dispatchEvent(new CustomEvent('oh:discount-updated', { detail: controller.discountState }));
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-oh-cart-open]');
      if (trigger) { event.preventDefault(); open(); return; }
      if (event.target.closest('[data-oh-cart-close]')) { close(); return; }
      if (event.target.closest('[data-oh-cart-refresh]')) { runUpdate(() => controller.refresh()); return; }
      const discountRemove = event.target.closest('[data-oh-discount-remove]');
      if (discountRemove) {
        if (!controller.pending) controller.removeDiscount(discountRemove.dataset.ohDiscountRemove);
        return;
      }
      const remove = event.target.closest('[data-oh-line-remove]');
      if (remove) {
        event.preventDefault();
        if (controller.pending || controller.stale) return;
        runUpdate(() => controller.change(remove.dataset.ohLineRemove, 0));
      }
    });
    document.addEventListener('change', event => {
      const input = event.target.closest('[data-oh-line-quantity]');
      if (!input || input.readOnly || controller.pending || controller.stale) return;
      const entries = quantityEntries([input]);
      if (!entries) return;
      runUpdate(() => controller.change(entries[0].key, entries[0].quantity));
    });
    const checkoutReady = new WeakSet();
    document.addEventListener('submit', event => {
      const form = event.target;
      if (form.matches('[data-oh-discount-form]')) {
        event.preventDefault();
        if (!controller.pending) controller.applyDiscount(new FormData(form).get('discount'));
        return;
      }
      if (!form.matches('[data-oh-cart-form]')) return;
      if (event.submitter?.name === 'checkout') {
        if (checkoutReady.delete(form)) return;
        event.preventDefault();
        if (controller.pending) { notices(translate('updating')); return; }
        const entries = quantityEntries(form.querySelectorAll('[data-oh-line-quantity]'));
        if (!entries) return;
        const submitter = event.submitter;
        runUpdate(() => controller.prepareCheckout(entries)).then(result => {
          if (!result?.ready) return;
          checkoutReady.add(form);
          form.requestSubmit(submitter);
        });
        return;
      }
      event.preventDefault();
      if (controller.pending || controller.stale) return;
      const entries = quantityEntries(form.querySelectorAll('[data-oh-line-quantity]'));
      if (!entries) return;
      runUpdate(() => controller.update(entries));
    });
    window.addEventListener('pageshow', event => { if (event.persisted) controller.refresh().catch(() => {}); });
    if (controller.cart) {
      setPending(false);
      paintDiscount(controller.discountState);
      if (controller.hasLegacyOffers || pendingCode && controller.cart.item_count > 0 || !Array.isArray(controller.cart.discount_codes) && controller.cart.item_count > 0) controller.refresh().catch(() => {});
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
  } catch(e) { console.error(e); }
})();

})();
